// Components
import CheckBox from "../check-box/CheckBox";

// Target Group Selection Card
export default function TargetGroupSelectionCard({
  targetGroupData = {},

  isTargetGroupEnabled = false,
  setIsTargetGroupEnabled = () => {},
  campaignId,
}) {
  const { step, title, message } = targetGroupData || {};

  const btnClassName = `mt-4 px-3 border py-2 rounded-lg btn-action ${
    isTargetGroupEnabled ? "border-primary text-primary" : ""
  }`;

  return (
    <div className="card shadow mb-4 mt-3">
      <div className="d-flex justify-content-between">
        <div className="card-content">
          <p className="card__step">{step}</p>
          <p className="card__title">{title}</p>
          <p className="card__message">{message}</p>
        </div>
        <div className="card-action">
          <div className={btnClassName}>
            <CheckBox
              boxStyle="p-0 mb-0 d-flex align-items-center"
              inputBoxStyle="m-0 mx-1"
              checked={isTargetGroupEnabled}
              onChange={() => setIsTargetGroupEnabled(!isTargetGroupEnabled)}
              checkBoxKey="Enable Target Group"
              disabled={campaignId} // disable for uploading in existing campaign
            />
          </div>

          {/* if uploading excel to existing campaign then froze the tg selection */}
          {campaignId && (
            <p className="text-primary my-2 font-weight-bold text-center">
              TARGET GROUP FROZEN
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
